import React from "react";
import PropTypes from "prop-types";

export default class Allocation extends React.Component {
  static propTypes = {
    allocation: PropTypes.object.isRequired,
    isSelected: PropTypes.bool.isRequired,
    onSelectAllocation: PropTypes.func.isRequired,
  };

  constructor(props, context) {
    super(props, context);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { allocation, onSelectAllocation, isSelected } = this.props;

    onSelectAllocation(allocation, !isSelected);
  }

  render() {
    const { allocation, isSelected, idx } = this.props;

    return (
      <div
        className="cause-select primary-hover-background"
        tab-index={idx}
        onClick={this.handleClick}
        aria-label={allocation.get("name")}>
        <div className="pull-left circle-50">
          <img
            src={allocation.get("img")}
            className="full-h"
            alt={allocation.get("name")}
          />
        </div>
        <h3 className="cause-name">{allocation.get("name")}</h3>
        <button
          data-testid="t-Allocat-click-to-add"
          className="voting-check"
          aria-label="Click to add">
          <i className="fa fa-arrow-circle-right secondary-color-text" />
        </button>
      </div>
    );
  }
}
